import { setLastCenter, setZoom } from '../reducers/geolocationSlice';

const locationMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case setLastCenter.toString():
      next(action);
      localStorage.setItem('lastCurrentLocation', JSON.stringify(action.payload.position));
      break;
    case setZoom.toString():
      next(action);
      localStorage.setItem('lastZoom', JSON.stringify(action.payload.zoom));
      break;
    default:
      next(action);
      break;
  }
};

export default locationMiddleware;
